import { AxiosPromise } from "axios";
import {
  CategoryDto,
  CategoryResourceApi,
} from "../generated/dashboard-client";
import { dashboardApiConfig, ops } from "./config";

const api = new CategoryResourceApi(dashboardApiConfig);

const CategoriesApi = {
  getSearchableCategories(): AxiosPromise<CategoryDto[]> {
    return api.getSearchableCategories(ops());
  },
};

export default CategoriesApi;
